import React, { useState } from 'react';
import { Section } from '../Styled';
import { FaqKort, FaqElement, FaqPara } from './WebFaq.styled';

const WEBFAQ = [
  {
    id: 'faq1',
    key: '0',
    title: 'Hvordan laver I min hjemmeside?',
    body: 'Vi specialicere os indenfor App udvikling og arbejder primært i et framework passende dette. Normal vis laver vi din hjemmeside i React. Ønsker du ikke en hjemmeside med funktioner (Altså en WebApp), har vi også muligheden for at lave din hjemmeside i et Content Management System som Wordpress eller Shopify.',
  },
  {
    id: 'faq2',
    key: '1',
    title: 'Hvor lang tid tager det at lave en hjemmeside?',
    body: 'Det er alt afhængigt af, hvad der skal være på dit site. Ønsker du en masse funktioner og indhold kan du forvente en længere ventetid. Det samme gælder, hvis du ønsker et dashboard med mere. Det kan afvige fra 2 uger til 3 måneder, men vi har et gennemsnit på 1 måned.',
  },
  {
    id: 'faq3',
    key: '2',
    title: 'Jeg vil gerne have en WebApp men har ikke noget Brand?',
    body: 'Ingen grund til bekymring! For et ekstra beløb sørger vi for din digitale identitet, brand building og Logo generering.',
  },
  {
    id: 'faq4',
    key: '3',
    title: 'Hvor mange ændringer har jeg?',
    body: 'Vores arbejdsproces på store projekter følger "SCRUM" modellen. Det vil sige når vi har lavet skelettet, holder vi et møde angående hvad der ønskes at blive ændret, tilføjet med mere. På mindre projekter tilbyder vi 2 ændringer.',
  },
];

const WebFaq = () => {
  const [currentlyOpen, setOpen] = useState(null);

  const openFaq = (i) => {
    setOpen(i);
  };

  return (
    <Section>
      <FaqKort>
        {WEBFAQ.map(faqItem => (
          <FaqElement
            id={faqItem.id}
            key={faqItem.key}
            onClick={() => openFaq(faqItem.id)}
            className={currentlyOpen === faqItem.id ? 'active' : ''}
          >
            <div>
              <h1>{faqItem.title}</h1>
            </div>
            <div>
              <FaqPara>{faqItem.body}</FaqPara>
            </div>
          </FaqElement>
        ))}
      </FaqKort>
    </Section>
  );
};

export default WebFaq;
